import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row w-full mtop-10" }
const _hoisted_6 = { class: "col-0-8 colend mright-04" }
const _hoisted_7 = { class: "main-m font-m" }
const _hoisted_8 = { class: "row w-full mtop-10" }
const _hoisted_9 = { class: "col-0-8 colend mright-04" }
const _hoisted_10 = { class: "main-m font-m" }
const _hoisted_11 = { class: "col-0-6 colend mright-04 mleft-04" }
const _hoisted_12 = { class: "main-m font-m" }
const _hoisted_13 = { class: "row w-full mtop-10" }
const _hoisted_14 = { class: "col-0-8 colend mright-04" }
const _hoisted_15 = { class: "main-m font-m" }
const _hoisted_16 = { class: "mtop-10" }
const _hoisted_17 = { class: "row w-full mtop-10" }
const _hoisted_18 = { class: "col-0-8 colend mright-04" }
const _hoisted_19 = { class: "main-m font-m" }
const _hoisted_20 = { class: "row w-full mtop-10" }
const _hoisted_21 = { class: "col-0-8 colend mright-04" }
const _hoisted_22 = { class: "main-m font-m" }
const _hoisted_23 = { class: "row w-full mtop-10" }
const _hoisted_24 = { class: "col-0-8 colend mright-04" }
const _hoisted_25 = { class: "main-m font-m" }
const _hoisted_26 = { class: "row w-full mtop-10" }
const _hoisted_27 = { class: "col-0-8 colend mright-04" }
const _hoisted_28 = { class: "main-m font-m" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "mtop-10" }
const _hoisted_31 = { class: "subgrid gap-04 mtop-10" }
const _hoisted_32 = { class: "mleft-10 font-m main-m" }
const _hoisted_33 = { class: "mleft-10 font-m main-m" }
const _hoisted_34 = { class: "mleft-10 font-m main-m" }

import { ref, onMounted, watch } from "vue";
import { InstituteLightResponse, CreateUpdateInstituteRequest, InstituteResponse, AdminApi } from '@/apiGenerate/medserver';
import { useI18n } from "vue-i18n";
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import { InstituteRoleType } from "@/models/institute.model";
import { COUNTRY_LIST } from "@/functions/geo";
import { ApiError, ItemSelect } from "@/models/share.model";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { toastError } from "@/utils/toast-utils";
import { useToast } from "primevue";
import EsSelectCountry from '@/components/esSelectCountry.vue';
import ToggleSwitch from "primevue/toggleswitch";


export default /*@__PURE__*/_defineComponent({
  __name: 'esInstituteForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    currentInstitute: {},
    confirmMethod: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const adminApi = new AdminApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();

const showExternalId = ref<boolean>(false);

const createUpdateInstituteRequest = ref<CreateUpdateInstituteRequest>({
  instituteId: undefined,
  name: undefined,
  shortName: undefined,
  externalId: undefined,
  instituteRole: Object.values(InstituteRoleType).find(item => item = InstituteRoleType.HealthProGroup),
  instituteAddress: {
    addressId: undefined,
    address: {
      street: undefined,
      postalCode: undefined,
      locality: undefined,
      isoCode: undefined
    }
  }
});

const instituteRoleTypes = ref<string[]>(Object.values(InstituteRoleType) as string[]);
const countries = ref<ItemSelect[]>([]);

const emits = __emit;

const countryToItemSelect = (country: {isoCode: string; term: string}): ItemSelect => {
  return {
    id: country.isoCode,
    label: country.term,
  }
}

const getCountries = () => {
  countries.value = COUNTRY_LIST.map((country: {isoCode: string; term: string}) => {
    return countryToItemSelect(country);
  });
}

const disablePID = () => {
  if (createUpdateInstituteRequest.value.instituteRole !== InstituteRoleType.HealthProGroup) {
    createUpdateInstituteRequest.value.pidactive = false;
  }
}

const getInstituteData = () => {
  if (props.currentInstitute && props.currentInstitute.id) {
    adminApi.getInstituteById({instituteId: props.currentInstitute.id}).then((result: InstituteResponse) => {
      createUpdateInstituteRequest.value = {
        instituteId: props.currentInstitute.id,
        name: result.name,
        shortName: result.shortName,
        externalId: result.externalId,
        instituteRole: result.instituteRole,
        pidactive: result.pidactive,
        fastPatientCreationActive: result.fastPatientCreationActive,
        ophthalmoDashboardActive: result.ophthalmoDashboardActive,
        instituteAddress: {
          addressId: result.instituteAddress.addressId ?? undefined,
          address: {
            street: result.instituteAddress.address.street ?? undefined,
            postalCode: result.instituteAddress.address.postalCode ?? undefined,
            locality: result.instituteAddress.address.locality ?? undefined,
            isoCode: result.instituteAddress.address.isoCode ?? undefined
          }
        }
      }

      showExternalId.value = createUpdateInstituteRequest.value.externalId != null;
    }).catch((error: ApiError) => {
        if (error.status) {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t(`error.${error.status}`)
            });
        } else {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t('error.DEFAULT')
            });
        }
    });
  }
}

const closeFormModal = () => {
  emits('modal-close');
}

const handleExternalIdToggle = (value: boolean) => {
  if (!value) {
    createUpdateInstituteRequest.value.externalId = undefined;
  }
}

const confirmFormModal = async () => {
  try {
    await props.confirmMethod(createUpdateInstituteRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
}

watch(
    () => props.isOpen,
   () => {
    if (props.currentInstitute) {
      getInstituteData();
    } else {
      createUpdateInstituteRequest.value = {
        instituteId: undefined,
        name: undefined,
        shortName: undefined,
        instituteRole: undefined,
        pidactive: undefined,
        instituteAddress: {
          addressId: undefined,
          address: {
            street: undefined,
            postalCode: undefined,
            locality: undefined,
            isoCode: undefined
          }
        }
      }
    }
  }
)

onMounted(() => {
  getCountries();
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_unref(t)('admin.institute.form.data')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.name')), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  class: "w-full",
                  size: "small",
                  type: "text",
                  modelValue: createUpdateInstituteRequest.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createUpdateInstituteRequest.value.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.shortName')), 1),
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  type: "text",
                  size: "small",
                  modelValue: createUpdateInstituteRequest.value.shortName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createUpdateInstituteRequest.value.shortName) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.role')), 1),
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(Select), {
                  modelValue: createUpdateInstituteRequest.value.instituteRole,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createUpdateInstituteRequest.value.instituteRole) = $event)),
                  onValueChange: _cache[3] || (_cache[3] = ($event: any) => (disablePID())),
                  options: instituteRoleTypes.value,
                  size: "small",
                  class: "w-full"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('admin.institute.form.externalId')), 1)
                ]),
                _createVNode(_unref(ToggleSwitch), {
                  class: "mright-10",
                  modelValue: showExternalId.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showExternalId).value = $event)),
                  onChange: _cache[5] || (_cache[5] = () => handleExternalIdToggle(showExternalId.value))
                }, null, 8, ["modelValue"]),
                (showExternalId.value)
                  ? (_openBlock(), _createBlock(_unref(InputText), {
                      key: 0,
                      type: "text",
                      size: "small",
                      modelValue: createUpdateInstituteRequest.value.externalId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createUpdateInstituteRequest.value.externalId) = $event))
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h4", _hoisted_16, _toDisplayString(_unref(t)('admin.institute.form.address')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.street')), 1),
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  class: "w-full",
                  type: "text",
                  size: "small",
                  modelValue: createUpdateInstituteRequest.value.instituteAddress.address.street,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createUpdateInstituteRequest.value.instituteAddress.address.street) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.postalCode')), 1),
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  type: "text",
                  size: "small",
                  modelValue: createUpdateInstituteRequest.value.instituteAddress.address.postalCode,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createUpdateInstituteRequest.value.instituteAddress.address.postalCode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.locality')), 1),
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(_unref(InputText), {
                  class: "w-full",
                  type: "text",
                  size: "small",
                  modelValue: createUpdateInstituteRequest.value.instituteAddress.address.locality,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createUpdateInstituteRequest.value.instituteAddress.address.locality) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, [
                    _createTextVNode(_toDisplayString(_unref(t)('admin.institute.form.country')), 1),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                  ])
                ]),
                _createVNode(EsSelectCountry, {
                  modelValue: createUpdateInstituteRequest.value.instituteAddress.address.isoCode,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createUpdateInstituteRequest.value.instituteAddress.address.isoCode) = $event)),
                  countries: countries.value,
                  default: false,
                  onChangeSelect: _cache[11] || (_cache[11] = currentCountry => createUpdateInstituteRequest.value.instituteAddress.address.isoCode = currentCountry),
                  "selected-data": countries.value.find(country => country.id === createUpdateInstituteRequest.value.instituteAddress.address.isoCode)
                }, null, 8, ["modelValue", "countries", "selected-data"])
              ]),
              (createUpdateInstituteRequest.value.instituteRole === _unref(InstituteRoleType).HealthProGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("h4", _hoisted_30, _toDisplayString(_unref(t)('admin.institute.form.options')), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('admin.institute.form.pidActivation')), 1),
                      _createVNode(_unref(ToggleSwitch), {
                        modelValue: createUpdateInstituteRequest.value.pidactive,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((createUpdateInstituteRequest.value.pidactive) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('admin.institute.form.fastPatientCreationActive')), 1),
                      _createVNode(_unref(ToggleSwitch), {
                        modelValue: createUpdateInstituteRequest.value.fastPatientCreationActive,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((createUpdateInstituteRequest.value.fastPatientCreationActive) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)('admin.institute.form.ophthalmoDashboard')), 1),
                      _createVNode(_unref(ToggleSwitch), {
                        modelValue: createUpdateInstituteRequest.value.ophthalmoDashboardActive,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((createUpdateInstituteRequest.value.ophthalmoDashboardActive) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_es_modal_footer, {
              onModalCancel: closeFormModal,
              confirmModalMethod: () => confirmFormModal()
            }, null, 8, ["confirmModalMethod"])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})